import Header from './shared/header';
import App from '../angular/app';
import ProductsByCategory from './widgets/products-by-category';
import Revealer from './shared/revealer';
import Zoomer from './shared/zoomer';
import Brands from './widgets/brands';
import Services from './widgets/services';
import SearchClearer from './shared/searchclearer';
Header();
App();
var productsByCategory = new ProductsByCategory('.widget-products-by-category');
productsByCategory.init();
var revealers = Array.from(document.querySelectorAll('.revealer'));
revealers.forEach(revealer => {
    var item = new Revealer(revealer);
    item.init();
});

// external redirect
$(document).on("click", "a[target='_blank']:not(.leave-website),.external", function (e) {
    var href = e.currentTarget.href;
    var hostUrl = window.location.origin;
    var modal = $("#leave-message");
    if (!href.includes(hostUrl) && modal.find($(e.currentTarget)).length == 0) {
        e.preventDefault();
        modal.find("a[target='_blank']").attr("href", href);
        var spanTag = "<span class='external-url'>" + href + "</span>";
        if (modal.html().includes("{url}")) {
            modal.html(modal.html().replace(/{url}/g, spanTag));
        }
        else {
            modal.find(".external-url").text(href);
        }
        modal.foundation('open');
    }
});

/*window.externalModalHandler = function(e, href) {
    var hostUrl = window.location.origin;
    var modal = $("#leave-message");
    if (!href.includes(hostUrl) && modal.find($(e.currentTarget)).length == 0) {
        e.preventDefault();
        modal.find("a[target='_blank']").attr("href", href);
        var spanTag = "<span class='external-url'>" + href + "</span>";
        if (modal.html().includes("{url}")) {
            modal.html(modal.html().replace(/{url}/g, spanTag));
        }
        else {
            modal.find(".external-url").text(href);
        }
        modal.foundation('open');
    } else {
        var newTab = window.open(href, '_blank');
        newTab.focus();
    }
}*/

// SearchClearer 
var SearchClearers = Array.from(document.querySelectorAll('.clear-search'));
SearchClearers.forEach(searcher => {
    var item = new SearchClearer(searcher);
    item.init();
});
var productIntro = document.querySelector('.widget-intro.variant-product');
if (productIntro) {
    var zoomer = new Zoomer({
        trigger: productIntro.querySelector('.zoomer'),
        aligner: productIntro.querySelector('.product-info'),
        images: productIntro.querySelectorAll('.product-image img')
    });
    zoomer.init();
}
var brands = Array.from(document.querySelectorAll('.widget-brands.layout-brands'));
brands.forEach(brand => {
    var item = new Brands(brand);
    item.init();
})
var services = Array.from(document.querySelectorAll('.widget-services'));
services.forEach(service => {
    var item = new Services(service);
    item.init();
})

$(document).foundation();

// Document Search products filter
$(function () {
    let $products = $("#filter-products-dd");
    if ($products.length > 0) {
        $("#document-search-discontinued").on("change", function () {
            let checked = $(this).is(":checked");
            if (checked) {
                $products.children().filter("[data-discontined='True']").show();
            } else {
                $products.children().filter("[data-discontined='True']").hide();
            }
        }).trigger("change");
    }
});